import axios from '@/utils/axios'

export default {
  state: {
    status: 'standby',
    progress: null,
    total: null
  },

  getters: {},

  mutations: {
    uploadStart(state) {
      state.status = 'waiting'
    },
    uploadProgress(state, {progress, total}) {
      state.status = 'loading'
      state.progress = progress
      state.total = total
    },
    uploadReset(state) {
      state.status = 'standby'
      state.progress = null
      state.total = null
    },
  },

  actions: {
    async uploadForm({commit, getters, rootState}, {url}) {
      try {
        commit('uploadStart')

        const datas = {
          registration: rootState.user.registration,
          npo: rootState.user.npo,
          mouvement: rootState.user.mouvement,
          kilometers: getters.findDataByName('kilometers').value,
          comment: getters.findDataByName('comment').value,
          counterInMiles: getters.findDataByName('counterInMiles').value,
          counterPicture: {
            datetime: getters.findDataByName('counterPicture').value.datetime,
            data: getters.findDataByName('counterPicture').value.data,
          },
          registrationPicture: {
            datetime: getters.findDataByName('registrationPicture').value.datetime,
            data: getters.findDataByName('registrationPicture').value.data,
          },
        }

        await axios.post(url, datas, {
          onUploadProgress(e) {
            commit('uploadProgress', {
              progress: e.loaded,
              total: e.total,
            })
          }
        })

        commit('uploadReset')
      } catch(error) {
        commit('uploadReset')
        throw 'Impossible d\'envoyer le formulaire : ' + error.message
      }
    }
  }
}
